import React, { useMemo } from "react";
import { Form, Select, Spin } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import ConditionalWrapper from "misc/conditional/ConditionalWrapper";

const CustomerRootUser = ({ form, name, value, label, layout = "vertical", members = [], isLoading }) => {
    const [t] = useTranslation();
    const options = useMemo(() => {
        return members.map(member => ({
            label: member?.email,
            value: member.id
        }));
    }, [members]);

    return (
        <Form form={form} initialValues={{ [name]: value }} layout={layout}>
            <Form.Item name={name} label={label} rules={[{ required: true, message: t("t_customer_owner_are_required") }]}>
                <ConditionalWrapper condition={isLoading} wrapper={children => <Spin indicator={null}>{children}</Spin>}>
                    <Select
                        filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                        options={options}
                        showSearch
                        placeholder={t("t_select_customer_owner")}
                        style={{ width: "100%" }}
                        onChange={value => {
                            form.setFieldsValue({ [name]: value });
                        }}
                        defaultValue={value}
                    />
                </ConditionalWrapper>
            </Form.Item>
        </Form>
    );
};

CustomerRootUser.propTypes = {
    form: PropTypes.any.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
    members: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            email: PropTypes.string.isRequired
        })
    ).isRequired,
    isLoading: PropTypes.bool.isRequired
};

export default CustomerRootUser;
